import { createContext } from "react";

export const ShotContext = createContext();
export const ShotProvider = ShotContext.Provider;
export const ShotConsumer = ShotContext.Consumer;
